import { Link } from 'react-router-dom';
import RoleGate from '@/components/RoleGate';

const ENTRIES = [
  { icon: 'ri-dashboard-3-line', title: '营运总览', desc: '会员、用量与营收摘要', href: '/admin/operations' },
  { icon: 'ri-team-line', title: '会员管理', desc: '会员查询、点数与帐号', href: '/admin/operations' },
  { icon: 'ri-coins-line', title: '点数 / 帐务流水', desc: '扣点规则与流水（只读摘要）', href: '/admin/operations' },
  { icon: 'ri-megaphone-line', title: '公告 / 私讯通知', desc: '会员通知（建设中）' },
  { icon: 'ri-shield-keyhole-line', title: '功能权限管理', desc: '功能开关与权限（建设中）' },
  { icon: 'ri-wallet-3-line', title: 'API 余额警戒摘要', desc: '供应商余额摘要，不含完整 Key', href: '/admin/operations' },
  { icon: 'ri-shield-check-line', title: '风控词汇与替代表达', desc: '入口占位，完整后台后续迭代' },
  { icon: 'ri-chat-quote-line', title: '话术模板', desc: '入口占位，完整后台后续迭代' },
];

export default function BusinessConsolePage() {
  return (
    <RoleGate allow={['dev_admin', 'super_admin']} deniedTitle="此页仅限管理员">
      <div className="max-w-4xl mx-auto px-4 py-10">
        <div className="flex items-center gap-2 text-xs text-secondary-400 mb-2">
          <Link to="/" className="hover:text-foreground-600">工作台</Link>
          <i className="ri-arrow-right-s-line" />
          <span>商业营运控制台</span>
        </div>
        <h1 className="text-2xl font-bold text-foreground-950">Business Operations Console</h1>
        <p className="text-sm text-foreground-600 mt-1 mb-6">会员、点数、营运数据与 API 余额摘要。技术 raw 页请使用平台稳定控制台。</p>
        <div className="grid sm:grid-cols-2 gap-3">
          {ENTRIES.map((e) => (
            <div key={e.title} className="rounded-xl border border-secondary-200 bg-background-50 p-4">
              <div className="flex items-center gap-2 text-sm font-semibold text-foreground-900">
                <i className={`${e.icon} text-primary-500`} />
                {e.title}
              </div>
              <p className="text-xs text-secondary-500 mt-2">{e.desc}</p>
              {e.href ? (
                <Link to={e.href} className="inline-block mt-3 text-xs text-primary-600 font-medium hover:underline">进入完整营运后台 →</Link>
              ) : (
                <span className="inline-block mt-3 text-[10px] px-2 py-0.5 rounded bg-secondary-100 text-secondary-500">建设中</span>
              )}
            </div>
          ))}
        </div>
      </div>
    </RoleGate>
  );
}
